// extracted by mini-css-extract-plugin
export default {"titleTag":"titleTag___TNb56","listCrossGroupItems":"listCrossGroupItems___bDz5L"};